var lastScrollTop = 0;
window.addEventListener("scroll",function() {
    if($(".product-form--regular").length) {
      var st = window.pageYOffset || document.documentElement.scrollTop;
      var offset = $(".product-form--regular").offset().top;
      if (st > offset) {
        document.getElementById("arkon").classList.add("scrolled");
      } else if (st < offset) { 
        document.getElementById("arkon").classList.remove("scrolled");
      }
      lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
    }
  }, false);

jQuery(document).ready(function($){
    $('.meteor-menu .m-container .m-sub-links').each(function(){
        var moreContent = $(this).find('.m-large-detail-item .m-link-details').html();
        $(this).find('.m-sub-links-inner .m-sub-links-wrapper').append('<div class="m-link-details-right">'+moreContent+'</div>'); 
    });
  $('.m-link-details-right a.m-link-title').prepend(' Shop all');

  $(".accordion > .accordion-item.is-active").children(".accordion-panel").slideDown();
  $(".accordion > .accordion-item").click(function() {
      // Cancel the siblings
      $(this).siblings(".accordion-item").removeClass("is-active").children(".accordion-panel").slideUp();
      // Toggle the item
      $(this).toggleClass("is-active").children(".accordion-panel").slideToggle("ease-out");
  });

  $('.icons-header-slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 4000,
    prevArrow:"<button type='button' class='slick-prev slick-arrow' aria-label='Previous'><svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='#cbcbcb' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-left'><polyline points='15 18 9 12 15 6'></polyline></svg></button>",
    nextArrow:"<button type='button' class='slick-next slick-arrow' aria-label='Next'><svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='#cbcbcb' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'><polyline points='9 18 15 12 9 6'></polyline></svg></button>",        
  });
  $('.reviews_carousel').slick({
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      autoplay: false,
      prevArrow:"<button type='button' class='slick-prev slick-arrow' aria-label='Previous'><svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='#cbcbcb' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-left'><polyline points='15 18 9 12 15 6'></polyline></svg></button>",
      nextArrow:"<button type='button' class='slick-next slick-arrow' aria-label='Next'><svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='#cbcbcb' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'><polyline points='9 18 15 12 9 6'></polyline></svg></button>", 
      responsive: [
        {
            breakpoint: 859,
            settings: {
                slidesToShow: 3,
            }
        },
        {
            breakpoint: 640,
            settings: {
                slidesToShow: 1,
            }
        }
      ]
  });
});




document.addEventListener('variant:change', function(event){
  const variant = event.detail?.variant;

  if(!variant) return;

  const price = document.querySelector('[data-price]');

  if(price){
    price.innerHTML = Shopify.formatMoney(
      variant.price,
      window.Shopify.money_format
    );
  }

  const comparePrice = document.querySelector('[data-price-compare]');

  if(comparePrice && variant.compare_at_price){
    comparePrice.innerHTML = Shopify.formatMoney(
      variant.compare_at_price,
      window.Shopify.money_format
    );
  }
});


